import { connect } from 'react-redux';

import { State } from 'store/types';
import SwitchView from './Switch';


const mapStateToProps = (state: State) => {
  const { remoteConfig } = state;
  return {
    priceRevealConfig: remoteConfig.configs.priceReveal,
  };
};

export default connect(mapStateToProps)(SwitchView);

